export default {"src":"/_next/static/media/cal-logo-light.91da0aec.svg","height":22,"width":101,"blurWidth":0,"blurHeight":0};